// extracted by mini-css-extract-plugin
export default {"icons":"styles_icons__q0y+d"};